import { findCinemaId } from 'global/helpers'
import { getCinemaSlug } from 'pages/Hall/helpers'
import { select } from 'redux-saga/effects'

export default function* gtmAddTickets(numberOfTickets) {
    const cinemaid = yield select((state) => findCinemaId(state))
    const site = getCinemaSlug(cinemaid)
    const movieData = yield select((state) => state?.pages?.hall?.movie?.data)
    const ref = window.localStorage.getItem('referer')

    dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            currency: 'CZK',
            value: 0,
            items: [
                {
                    affiliation: 'Cinestar',
                    item_list_id: ref,
                    item_list_name: ref,
                    item_id: movieData.eventid,
                    item_name: movieData.title,
                    item_brand: site,
                    item_category: '',
                    item_category2: 'Film',
                    discount: 0,
                    price: 0,
                    quantity: numberOfTickets,
                },
            ],
        },
    })
}
